import type { files } from '@wix/media';

type MediaManagerResponse = { items: files.FileDescriptor[] };

/** @ignore */
export type OpenMediaManager = (options?: {
  category?: string;
  multiSelect?: boolean;
}) => Promise<MediaManagerResponse | undefined>;
